var Device = Object.freeze({
  getInfo: function getInfo() {
    return Promise.resolve({
      model: "",
      systemName: "",
      systemVersion: "",
      interfaceIdiom: "",
      isSimulator: false
    });
  },
  getLocalizationInfo: function getLocalizationInfo() {
    return Promise.resolve({
      localeIdentifier: "",
      preferredLanguages: [],
      calendarIdentifier: "",
      timeZoneIdentifier: "",
      timeZoneOffsetSeconds: 0
    });
  }
});
export {
  Device
};
//# sourceMappingURL=unavailable.js.map
